export default __webpack_public_path__ + "static/gestionamos-0359c7928bb53069f61ee5536f98bcb4.png";